var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.86 16.56H38a1.86 1.86 0 0 1 2 2v10a1.88 1.88 0 0 1-2 2H27.81v-1.13a1.9 1.9 0 0 0-2.09-2.08h-1.58a1.88 1.88 0 0 0-1.95 2v1.33H12a1.87 1.87 0 0 1-2-2v-10a1.85 1.85 0 0 1 2-2h7.11v-1.19a3.51 3.51 0 0 1 3.62-3.64h4.56a3.51 3.51 0 0 1 3.55 3.55Zm-5.85 0h4.08c.3 0 .39-.09.37-.38s0-.54 0-.81a2.08 2.08 0 0 0-2.07-2.1h-4.78a2.07 2.07 0 0 0-2.05 2v.88c0 .29.08.41.39.4ZM10.93 32.19h11.26v1.22a1.89 1.89 0 0 0 2.06 2.06h1.65a1.87 1.87 0 0 0 1.9-1.85V32.2H39v4.41a1.39 1.39 0 0 1-1.53 1.53H12.44a1.39 1.39 0 0 1-1.51-1.51v-4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.13 31.52v-1.81a.88.88 0 0 1 .95-.95h1.84a.87.87 0 0 1 .93.9v3.72a.86.86 0 0 1-.88.88h-1.95a.87.87 0 0 1-.89-.94v-1.8Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon-01.svg";
export { ForwardRef as ReactComponent };